import AxiosAPI from "@qualitas/libs";
import { AxiosResponse } from "axios";

import { TemplateAdministrationOfficeUpsert, TemplateAdministrationOfficeUserUpsert } from "../Models";

export const OfficesAdminAPI = (baseURL: string | undefined, clientId: string) => {
	const api = AxiosAPI({
		baseURL,
		clientId,
		isApp: true,
		hasUnderMaintenance: false
	});

	const getAdministrationData = () => {
		const serviceUrl = `/bookbuilding-api/Offices/GetAdministrationData`;
		return api.get(serviceUrl)
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const saveAdministrationOffice = (data: TemplateAdministrationOfficeUpsert) => {
		const serviceUrl = `/bookbuilding-api/Offices/SaveAdministrationOffice`;
		return api.post(serviceUrl, data)
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const deleteAdministrationOffice = (id: number) => {
		const serviceUrl = `/bookbuilding-api/Offices/DeleteAdministrationOffice`;
		return api.delete(serviceUrl, { params: { id } })
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const saveAdministrationOfficeUser = (data: TemplateAdministrationOfficeUserUpsert) => {
		const serviceUrl = `/bookbuilding-api/Offices/SaveAdministrationOfficeUser`;
		return api.post(serviceUrl, data)
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const deleteAdministrationOfficeUser = (id: number) => {
		const serviceUrl = `/bookbuilding-api/Offices/DeleteAdministrationOfficeUser`;
		return api.delete(serviceUrl, { params: { id } })
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	return {
		getAdministrationData,
		saveAdministrationOffice,
		deleteAdministrationOffice,
		saveAdministrationOfficeUser,
		deleteAdministrationOfficeUser
	};
};
